module.exports = "<symbol id=\"tt-icon-sort\" viewBox=\"0 0 24 24\"><path d=\"M4.12 10.63h15.77v2.74H4.12zM.09 4.04h23.82v2.74H.09zM9.15 17.21h5.71v2.74H9.15z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/Rdhcya1h7lLN3rcsite/assets/svg/pdp-page/sort.svg
// module id = 280
// module chunks = 10